// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZUEL","name":"Header_name__3EVyQ","birthday":"Header_birthday__3G2gP","skeleton":"Header_skeleton__11ND1"};